// Тонкая обёртка над fetch с поддержкой cookie-сессии и CSRF.
// CSRF-токен бэк отдаёт в ответе /api/auth/login и /api/auth/me — храним в памяти модуля.

let csrfToken = null;

export function setCsrfToken(t) { csrfToken = t || null; }
export function getCsrfToken() { return csrfToken; }

export class ApiError extends Error {
  constructor(message, { status, code, payload } = {}) {
    super(message);
    this.status = status;
    this.code = code;
    this.payload = payload;
  }
}

async function request(method, path, body) {
  const headers = { Accept: 'application/json' };
  let payload;
  if (body !== undefined) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  }
  if (method !== 'GET' && method !== 'HEAD' && csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
  }

  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers,
    body: payload,
  });

  if (res.status === 204) return null;

  const text = await res.text();
  let data = null;
  let parseError = null;
  if (text) {
    try { data = JSON.parse(text); }
    catch (e) { parseError = e; }
  }

  if (!res.ok) {
    // Сервер мог вернуть HTML вместо JSON (фатальная ошибка PHP) — тогда
    // показываем кусок текста, а не «HTTP 500». Иначе — message из JSON.
    const err = data?.error;
    let msg = err?.message;
    if (!msg) {
      if (parseError && text) {
        // Грубая выжимка: убираем HTML-теги, оставляем первые ~200 символов.
        msg = text.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 200);
        if (!msg) msg = `HTTP ${res.status}`;
      } else {
        msg = `HTTP ${res.status}`;
      }
    }
    throw new ApiError(msg, {
      status: res.status,
      code: err?.code,
      payload: data ?? text,
    });
  }
  if (parseError) throw new ApiError('Сервер вернул не-JSON ответ', { status: res.status, payload: text });
  return data;
}

/**
 * POST multipart/form-data (загрузка файлов). Тело — FormData. Заголовок
 * Content-Type выставляет fetch сам с правильным boundary.
 */
async function postForm(path, form) {
  const headers = { Accept: 'application/json' };
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: form,
  });
  if (res.status === 204) return null;
  const text = await res.text();
  let data = null;
  let parseError = null;
  if (text) { try { data = JSON.parse(text); } catch (e) { parseError = e; } }
  if (!res.ok) {
    const err = data?.error;
    const msg = err?.message || `HTTP ${res.status}`;
    throw new ApiError(msg, { status: res.status, code: err?.code, payload: data ?? text });
  }
  if (parseError) throw new ApiError('Сервер вернул не-JSON ответ', { status: res.status, payload: text });
  return data;
}

export const api = {
  get:    (path)         => request('GET',    path),
  post:   (path, body)   => request('POST',   path, body ?? {}),
  put:    (path, body)   => request('PUT',    path, body ?? {}),
  patch:  (path, body)   => request('PATCH',  path, body ?? {}),
  delete: (path)         => request('DELETE', path),
  postForm: (path, form) => postForm(path, form),
};
